import { initializeApp } from 'firebase/app'
import { getAnalytics, isSupported, logEvent } from 'firebase/analytics'

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: 'go-defi.firebaseapp.com',
  projectId: 'go-defi',
  storageBucket: 'go-defi.appspot.com',
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_API_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
}

const app = initializeApp(firebaseConfig)
const analytics = isSupported().then((supp) => (supp ? getAnalytics(app) : null))

export const logCustomEvent = async (event: string) => {
  if (!analytics || process.env.NODE_ENV !== 'production') return
  logEvent(getAnalytics(), event, { platform: 'web' })
}
